import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ClientService } from '@common/services/ClientService/ClientService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { ClientsData } from '@common/models/clientsData.model';
import { QueryParameters } from '@common/models/queryParameters.model';

@Component({
  templateUrl: './clientsView.component.html',
  styleUrls: ['./clientsView.component.scss'],
})
export class ClientsViewComponent implements OnInit {
  clientsData: ClientsData = {
    clients: [],
    clientsNumber: 0,
  };
  queryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };
  dataFetchingTimeout;
  @ViewChild('clientsTableComponent') clientsTableComponent: SortableTableComponent;

  public fields = [
    { shortName: 'clientName', fullName: 'clientName', type: 'string', sortable: true, width: '74%' },
    { shortName: 'areasNumber', fullName: 'areas', type: 'string', sortable: true, width: '15%', textAlign: 'center' },
  ];

  constructor(
    public authService: AuthService,
    public clientService: ClientService,
  ) {}

  ngOnInit() {
    this.getViewData();
  }

  getViewData() {
    const {
      query,
      orderBy,
      sortOrder,
      page,
    } = this.queryParameters;

    this.clientService.getClients({ query, orderBy, sortOrder, page })
      .subscribe(
        (data: ClientsData) => {
          this.clientsData = data;

          if (this.clientsTableComponent) {
            this.clientsTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getViewData.bind(this)),
      );
  }

  onParametersUpdated($event) {
    this.queryParameters = Object.assign(this.queryParameters, $event);
    this.getDataWithTimeout(this.getViewData.bind(this));
  }

  getDataWithTimeout(fn) {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/clients/views/clientsView/clientsView.component.ts